import { setupI18n } from '@lingui/core'
import { messages as enMenu } from '@tecsinapse-org/portal-menu-kit/build/locales/en/messages'
import { messages as esMenu } from '@tecsinapse-org/portal-menu-kit/build/locales/es/messages'
import { messages as ptMenu } from '@tecsinapse-org/portal-menu-kit/build/locales/pt-br/messages'
import { messages as enMessages } from './core/locales/en/messages.mjs'
import { messages as esMessages } from './core/locales/es/messages.mjs'
import { messages as ptBrMessages } from './core/locales/pt-br/messages.mjs'

const messages = {
  en: { ...enMessages, ...enMenu },
  'pt-br': { ...ptBrMessages, ...ptMenu },
  es: { ...esMessages, ...esMenu }
}

export const i18n = setupI18n({
  locale: 'pt-br',
  locales: ['pt-br', 'es', 'en'],
  messages
})
